export default {
    namespaced: true,
    state: {
        loader: false
    },
    getters: {
        loader(state) {
            return state.loader;
        }
    },
    mutations: {
        loader(state, loader) {
            state.loader = loader;
        }
    },
    actions: {
        loader(context, value) {
            this.commit('app/loader', value);
        },
    }
};
